/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CreateManagerRequest,
  GetApiManagerList200,
  GetApiManagerListParams,
  GetApiSubManagersList200,
  GetApiSubManagersListParams,
  ManagerApiResource,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse,
  UpdateManagerRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiManagerListResponse200 = {
  data: GetApiManagerList200
  status: 200
}

export type getApiManagerListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiManagerListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiManagerListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiManagerListResponseSuccess = (getApiManagerListResponse200) & {
  headers: Headers;
};
export type getApiManagerListResponseError = (getApiManagerListResponse400 | getApiManagerListResponse401 | getApiManagerListResponse403) & {
  headers: Headers;
};

export type getApiManagerListResponse = (getApiManagerListResponseSuccess | getApiManagerListResponseError)

export const getGetApiManagerListUrl = (params?: GetApiManagerListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/managers?${stringifiedParams}` : `/api/managers`
}

export const getApiManagerList = async (params?: GetApiManagerListParams, options?: RequestInit): Promise<getApiManagerListResponse> => {
  
  return customFetch<getApiManagerListResponse>(getGetApiManagerListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiManagerCreateResponse204 = {
  data: void
  status: 204
}

export type postApiManagerCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiManagerCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiManagerCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiManagerCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiManagerCreateResponseSuccess = (postApiManagerCreateResponse204) & {
  headers: Headers;
};
export type postApiManagerCreateResponseError = (postApiManagerCreateResponse400 | postApiManagerCreateResponse401 | postApiManagerCreateResponse403 | postApiManagerCreateResponse409) & {
  headers: Headers;
};

export type postApiManagerCreateResponse = (postApiManagerCreateResponseSuccess | postApiManagerCreateResponseError)

export const getPostApiManagerCreateUrl = () => {


  

  return `/api/managers`
}

export const postApiManagerCreate = async (createManagerRequest: CreateManagerRequest, options?: RequestInit): Promise<postApiManagerCreateResponse> => {
  
  return customFetch<postApiManagerCreateResponse>(getPostApiManagerCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createManagerRequest,)
  }
);}


export type putApiManagerUpdateResponse200 = {
  data: ManagerApiResource
  status: 200
}

export type putApiManagerUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiManagerUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiManagerUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiManagerUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiManagerUpdateResponseSuccess = (putApiManagerUpdateResponse200) & {
  headers: Headers;
};
export type putApiManagerUpdateResponseError = (putApiManagerUpdateResponse400 | putApiManagerUpdateResponse401 | putApiManagerUpdateResponse403 | putApiManagerUpdateResponse409) & {
  headers: Headers;
};

export type putApiManagerUpdateResponse = (putApiManagerUpdateResponseSuccess | putApiManagerUpdateResponseError)

export const getPutApiManagerUpdateUrl = (id: number,) => {


  

  return `/api/managers/${id}`
}

export const putApiManagerUpdate = async (id: number,
    updateManagerRequest: UpdateManagerRequest, options?: RequestInit): Promise<putApiManagerUpdateResponse> => {
  
  return customFetch<putApiManagerUpdateResponse>(getPutApiManagerUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateManagerRequest,)
  }
);}


export type getApiSubManagersListResponse200 = {
  data: GetApiSubManagersList200
  status: 200
}

export type getApiSubManagersListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiSubManagersListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSubManagersListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiSubManagersListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiSubManagersListResponseSuccess = (getApiSubManagersListResponse200) & {
  headers: Headers;
};
export type getApiSubManagersListResponseError = (getApiSubManagersListResponse400 | getApiSubManagersListResponse401 | getApiSubManagersListResponse403 | getApiSubManagersListResponse404) & {
  headers: Headers;
};

export type getApiSubManagersListResponse = (getApiSubManagersListResponseSuccess | getApiSubManagersListResponseError)

export const getGetApiSubManagersListUrl = (supervisorId: number,
    params?: GetApiSubManagersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/managers/${supervisorId}/sub-managers?${stringifiedParams}` : `/api/managers/${supervisorId}/sub-managers`
}

export const getApiSubManagersList = async (supervisorId: number,
    params?: GetApiSubManagersListParams, options?: RequestInit): Promise<getApiSubManagersListResponse> => {
  
  return customFetch<getApiSubManagersListResponse>(getGetApiSubManagersListUrl(supervisorId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type deleteApiSubManagersRemoveResponse204 = {
  data: void
  status: 204
}

export type deleteApiSubManagersRemoveResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type deleteApiSubManagersRemoveResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiSubManagersRemoveResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiSubManagersRemoveResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiSubManagersRemoveResponseSuccess = (deleteApiSubManagersRemoveResponse204) & {
  headers: Headers;
};
export type deleteApiSubManagersRemoveResponseError = (deleteApiSubManagersRemoveResponse400 | deleteApiSubManagersRemoveResponse401 | deleteApiSubManagersRemoveResponse403 | deleteApiSubManagersRemoveResponse404) & {
  headers: Headers;
};

export type deleteApiSubManagersRemoveResponse = (deleteApiSubManagersRemoveResponseSuccess | deleteApiSubManagersRemoveResponseError)

export const getDeleteApiSubManagersRemoveUrl = (supervisorId: number,
    subManagerId: number,) => {


  

  return `/api/managers/${supervisorId}/sub-managers/${subManagerId}`
}

export const deleteApiSubManagersRemove = async (supervisorId: number,
    subManagerId: number, options?: RequestInit): Promise<deleteApiSubManagersRemoveResponse> => {
  
  return customFetch<deleteApiSubManagersRemoveResponse>(getDeleteApiSubManagersRemoveUrl(supervisorId,subManagerId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


